import {Injectable} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import {CurrentUserService} from '../../services/current-user/current-user.service';
import 'rxjs/add/observable/from';
import 'rxjs/add/observable/of';
import {UserModel} from '../../models/UserModel';
import {Observer} from 'rxjs/Observer';

@Injectable()
export class PermissionGuard implements CanActivate {

  constructor(private currentUserService: CurrentUserService, private router: Router) { }

  canActivate(next: ActivatedRouteSnapshot,
              state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    return this.currentUserService.getCurrentUser().map((user: UserModel) => {
      if (next.data['permissions'] == null)
        return true;
      const can =  user.can(next.data['permissions']);
      if (!can)
        this.router.navigate(['error']);
      return can;
    });

  }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/user/guards/permission/permission.guard.ts